import React from "react";
import { Check, X } from "lucide-react";

const QuestionCard = ({
  question,
  options = [],
  selectedOption,
  onOptionSelect,
  isSubmitted = false,
  isQuestionChanging = false,
  getOptionState,
}) => {
  return (
    <div className="w-full">
      {/* Question */}
      <div className="rounded-2xl bg-purple-200 p-5 text-center text-gray-800 shadow mb-5">
        {question}
      </div>

      {/* Options */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {options.map((option, index) => {
          const optionState = getOptionState(option);

          const isCorrectOption = optionState === "correct";
          const isWrongOption = optionState === "wrong";
          const isSelectedOption = optionState === "selected";

          return (
            <div
              key={index}
              onClick={() =>
                !isSubmitted &&
                !isQuestionChanging &&
                onOptionSelect(option)
              }
              className={`w-full flex items-center gap-4 p-3 rounded-2xl border transition
                ${
                  isCorrectOption
                    ? "border-green-500 bg-green-100"
                    : isWrongOption
                    ? "border-red-500 bg-red-100"
                    : isSelectedOption
                    ? "border-[#4A235A] bg-purple-100"
                    : "bg-[#f8f6fb] border-gray-300"
                }
                ${
                  isSubmitted || isQuestionChanging
                    ? "cursor-default"
                    : "cursor-pointer"
                }`}
            >
              <div
                className={`w-8 h-8 shrink-0 border-2 rounded-full flex items-center justify-center transition
                ${
                  isCorrectOption
                    ? "bg-green-500 border-green-500 text-white"
                    : isWrongOption
                    ? "bg-red-500 border-red-500 text-white"
                    : isSelectedOption
                    ? "bg-[#4A235A] border-[#4A235A] text-white"
                    : "border-gray-400 text-transparent"
                }`}
              >
                {isCorrectOption ? (
                  <Check size={20} />
                ) : isWrongOption ? (
                  <X size={20} />
                ) : isSelectedOption ? (
                  <Check size={18} />
                ) : null}
              </div>

              <span className="text-lg text-gray-800">{option}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;